import React from "react";
import { isPercentageValue } from "./utils";
export const hasTags = ({ tags }) => !(!tags || tags.length === 0);
export const getTableColumnWidthProps = (column) => ({
    maxWidth: isPercentageValue(String(column.maxWidth)) ? undefined : column.maxWidth,
    width: isPercentageValue(String(column.width)) ? undefined : column.width,
});
const TableColumn = () => {
    return React.createElement(React.Fragment, null);
};
export default TableColumn;
//# sourceMappingURL=TableColumn.js.map